import React, { memo } from "react";
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";
import MdOutlineDragIndicator from "../../constants/icons/Md/MdOutlineDragIndicator";
import { isEditOwnAccess } from "../../utils/permissionsParser";

const DragAndDropContainer = ({
  items,
  onDragEnd,
  renderItem,
  renderLastRow,
  permissionDialogHandler = () => {},
  permissions,
  userId,
}) => {
  return (
    <DragDropContext onDragEnd={onDragEnd}>
      <Droppable droppableId="droppable">
        {(provided) => (
          <tbody {...provided.droppableProps} ref={provided.innerRef}>
            {items.map((item, index) => (
              <Draggable
                isDragDisabled={
                  !permissions?.edit &&
                  !isEditOwnAccess(permissions, userId, item.createdBy)
                }
                key={item._id}
                draggableId={item._id}
                index={index}
              >
                {(provided) => (
                  <tr
                    ref={provided.innerRef}
                    {...provided.draggableProps}
                    {...provided.dragHandleProps}
                  >
                    <td>
                      <div
                        onClick={() => {
                          if (
                            !permissions?.edit &&
                            !isEditOwnAccess(
                              permissions,
                              userId,
                              item.createdBy
                            )
                          ) {
                            permissionDialogHandler();
                          }
                        }}
                      >
                        <MdOutlineDragIndicator style={{ cursor: "grab" }} />
                      </div>
                    </td>
                    {renderItem(item, index)}
                  </tr>
                )}
              </Draggable>
            ))}
            {provided.placeholder}
            {renderLastRow()}
          </tbody>
        )}
      </Droppable>
    </DragDropContext>
  );
};

export default memo(DragAndDropContainer);
